import React from 'react'
import { UserRowEditorRenderer } from '@/components/report-tables/headers/userRowEditorRenderer'
import { definitionType } from '@/enums/definitionType'
import { RowEditorRenderer } from '@/components/report-tables/headers/rowEditorRenderer'
import { BankEditorRenderer } from '@/components/report-tables/headers/bankEditorRenderer'
import { BranchEditorRenderer } from '@/components/report-tables/headers/branchEditorRenderer'

const DefaultHeaderRenderer = (props) => {
  const isRowHeader = !props.col && !!props.row
  if (props.readOnly || !isRowHeader) return props.value
  function getRenderer () {
    if (props.isUserRow) return UserRowEditorRenderer
    switch (props.definitionType) {
      case definitionType.enum.UserDef: return RowEditorRenderer
      case definitionType.enum.BankDef: return BankEditorRenderer
      case definitionType.enum.BranchDef: return BranchEditorRenderer
      case definitionType.enum.BankDefResident: return BankEditorRenderer
      case definitionType.enum.BankDefNonResident: return BankEditorRenderer
    }
  }
  const Renderer = getRenderer()
  return Renderer ? <Renderer {...props} /> : props.value
}

export {
  DefaultHeaderRenderer
}



// WEBPACK FOOTER //
// ./src/components/report-tables/headers/index.js